import { useEffect, useRef } from 'react';
import { useSegment } from '@sparknz/journeys-common';

import {
  EventTrackingConfiguration,
  trackActionLayerViewEvent,
} from 'components/shop/MobilePlans/utils/trackActionLayerViewEvent';

export const useTrackActionLayerView = ({
  planDetails,
  eventName,
}: Omit<EventTrackingConfiguration, 'isBusiness'>) => {
  const planDetailsRef = useRef(planDetails);
  const { isBusiness } = useSegment();

  useEffect(() => {
    trackActionLayerViewEvent({
      planDetails: planDetailsRef.current,
      isBusiness,
      eventName,
    });
  }, [isBusiness, eventName]);
};
